import { QueryClient } from '@tanstack/react-query';

import { isApiError } from './errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /*
       * A 4xx is a settled answer — a bad id, a missing permission, a stubbed
       * route. Retrying it only delays the error the user needs to see. 5xx and
       * network failures are the transient ones worth a second attempt.
       */
      retry: (failureCount, error) =>
        isApiError(error) && error.status < 500 ? false : failureCount < 2,
      staleTime: 30_000,
      // Stock moves under you; a stale balance on a re-focused tab is worse
      // than a refetch, so this stays on.
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});
